import {createContext, useEffect, useState} from 'react';
import axios from 'axios'
import { arrayMove } from "@dnd-kit/sortable";

export const TripContext = createContext();

export const TripContextProvider = ({children}) => {
    const baseURL = "https://wegoscenic.com/";
    
    const Axios = axios.create({ baseURL: baseURL });

    const [tripData,setTripData] = useState({});

    const [tripMessages,setTripMessages] = useState([]);

    const [tripLoading,setTripLoading] = useState(false);


    const generateTrip = async (values) => {

        setTripLoading(true);

        if(tripMessages.length > 0) values.messages = tripMessages;

        console.log(values);

        const {data} = await Axios.post('bridge/trip/create_trip.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        console.log(data);

        if(!data.success && 'error' in data) alert(data.error);

        setTripData(data.success && data.trip_data ? data.trip_data : {});

        setTripMessages(data.success && data.messages ? data.messages : []);

        setTripLoading(false);
    }

    // DELETE TRIP POINT
    const addTripPoint = (id) => {
        console.log("trip points add",{
            ...tripData,
            park_list: [...tripData.park_list,id],
            park_list: [...tripData.park_list,id]
        });
        setTripData(prev => {
            return {
                ...prev,
                park_list: [...prev.park_list,id],
                park_list: [...prev.park_list,id]
            };
        });
    };

    // DELETE TRIP POINT
    const deleteTripPoint = (id) => {
        setTripData(prev => {
            return {
                ...prev,
                park_list: prev.park_list.filter(item => item !== id),
                park_list: prev.park_list.filter(item => item !== id)
            };
        });
    };

    // Reorder TRIP POINT
    const reorderTripPoints = (oldIndex, newIndex) => {
        setTripData(prev => ({
            ...prev,
            park_list: arrayMove(prev.park_list, oldIndex, newIndex),
            park_list: arrayMove(prev.park_list, oldIndex, newIndex)
        }));
    };

    return (
        <>
            <TripContext.Provider value={{tripData,generateTrip, addTripPoint, deleteTripPoint, reorderTripPoints,tripLoading}}>
                {children}
            </TripContext.Provider>
        </>
    );
}

export default TripContextProvider